const selectColor = (colors, score) => {
    switch (score) {
        case 1:
        case 2:
            return colors.belowAverage;
        case 3:
            return colors.average;
        case 4:
        case 5:
            return colors.aboveAverage;
        default:
            return null;
    }
};

export default selectColor;
